import { get } from 'lodash-es';
import * as React from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';

import { LearnerAndAccountRegistrationRootState } from '../../interfaces/basic';
import LearnerAndAccountRegistrationForm from './LearnerAndAccountRegistrationForm';
import LearnerAndAccountRegistrationVerificationForm from './LearnerAndAccountRegistrationVerificationForm';

const initialRootState: LearnerAndAccountRegistrationRootState = {
  gradeCode: '',
  gradeLabel: '',
  learner_account: {
    last_name: '',
    first_name: '',
    password: '',
    password_confirmation: '',
    inputted_by_parents: false,
    last_name_kana: '',
    first_name_kana: '',
    phone_number: '',
    email: '',
    grade_id: '',
    receive_latest_info: true,
    gender: undefined,
    gender_expression: undefined,
    receive_webdm_remind_permission: true,
  },
  verification: {
    code: '',
  },
  validatedLearnerAccount: false,
  sentMailToEnteredEmail: false,
  consentId: '',
};

const LearnerAndAccountRegistrationContainer: React.FC = () => {
  const location = useLocation();
  const gradeId: string = get(location.state, 'gradeId', '');
  const gradeCode: string = get(location.state, 'gradeCode', '');
  const gradeLabel: string = get(location.state, 'gradeLabel', '');

  const initialState = {
    ...initialRootState,
    learner_account: {
      ...initialRootState.learner_account,
      grade_id: gradeId,
    },
    gradeCode,
    gradeLabel,
  };
  const [rootState, setRootState] = React.useState(initialState);

  return (
    <Routes>
      <Route
        path="/learner"
        element={
          <LearnerAndAccountRegistrationForm {...{ setRootState, rootState }} />
        }
      />
      <Route
        path="/verification"
        element={
          <LearnerAndAccountRegistrationVerificationForm
            {...{ setRootState, rootState }}
          />
        }
      />
    </Routes>
  );
};

export default LearnerAndAccountRegistrationContainer;
